import { useEffect, useState } from 'react'
import { Box } from '@chakra-ui/react'
import { useAccount, useContractRead } from 'wagmi'
import { GameEntry, EnterSecret, GameResult, NoAction, RevealSecret } from './rps'
import { RPSContext } from '../context/RPSContext'
import RockPaperScissorsABI from '../assets/constants/abi/RockPaperScissors.json'
import NetworkMapping from '../assets/constants/network-mapping.json'

export default function RPSForm() {
  const { address } = useAccount()
  const [gameDetails, setGameDetails] = useState({
    player: '',
    initiator: '',
    initiator_state: 0,
    initiator_hash: '',
    responder: '',
    responder_state: 0,
    responder_hash: '',
    state: -1,
    winner: '',
    comment: '',
    formNumber: 1,
    initiator_random_str: '',
    responder_random_str: '',
  })

  useEffect(() => {
    if (address) {
      setGameDetails({ ...gameDetails, player: address })
    }
  }, [address])

  function nextForm(num: number) {
    setGameDetails({ ...gameDetails, formNumber: num })
  }

  useContractRead({
    address: NetworkMapping['80001']['RockPaperScissors'] as `0x${string}`,
    abi: RockPaperScissorsABI,
    functionName: 'getGameDetails',
    args: [gameDetails.initiator, gameDetails.responder],
    watch: true,
    enabled: !!gameDetails.initiator && !!gameDetails.responder,
    onSuccess(gameState: any) {
      setGameDetails({
        ...gameDetails,
        state: gameState.state,
        initiator_state: gameState.initiator_state,
        responder_state: gameState.responder_state,
        winner: gameState.winner,
        comment: gameState.comment,
        initiator_hash: gameState.initiator_hash,
        responder_hash: gameState.responder_hash,
        initiator_random_str: gameState.initiator_random_str,
        responder_random_str: gameState.responder_random_str,
      })
    },
  })

  useEffect(() => {
    if (gameDetails.state === 2 || gameDetails.state === 3) {
      nextForm(4)
    }
    if (gameDetails.state === 1) {
      if (
        (gameDetails.player === gameDetails.initiator && !gameDetails.initiator_random_str) ||
        (gameDetails.player === gameDetails.responder && !gameDetails.initiator_random_str)
      ) {
        nextForm(3)
      }
    }
  }, [gameDetails])

  return (
    <Box
      borderWidth="1px"
      rounded="lg"
      shadow="1px 1px 3px rgba(0,0,0,0.3)"
      maxW={{ base: 'xl', md: 'lg' }}
      p={{ base: '6' }}
      m="10px"
      as="form"
    >
      <RPSContext.Provider value={{ gameDetails, setGameDetails, nextForm }}>
        {gameDetails.formNumber === 1 && <GameEntry />}
        {gameDetails.formNumber === 2 && <EnterSecret />}
        {gameDetails.formNumber === 3 && <RevealSecret />}
        {gameDetails.formNumber === 4 && <GameResult />}
        {gameDetails.formNumber === 5 && <NoAction />}
      </RPSContext.Provider>
    </Box>
  )
}
